/**
 * @desc 批量生成编号
 */
const URL = "/rantion-srm";
import http, { updateResponse } from "@/http";
export function request(params: API.srm.batchStep.batchStep.Params, options?: any) {
  return updateResponse(
    http(URL + `/srm/supplierInfo/batchStep`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
